import { Card, Flex, Text } from '@radix-ui/themes';

interface SummarySectionCardProps {
  icon: React.ElementType;
  label: string;
  children: React.ReactNode;
}

export const SummarySectionCard = ({
  icon: Icon,
  label,
  children,
}: SummarySectionCardProps) => {
  return (
    <Card className="shadow-md p-2 mb-2">
      <Flex align="center" gap="3">
        <Icon />
        <Flex direction="column">
          <Text size="2" className="text-gray-500">
            {label}:
          </Text>
          <Text size="2">{children}</Text>
        </Flex>
      </Flex>
    </Card>
  );
};
